/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { or, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import Options from '@linc-technologies/linced-common/enums/options';
import { classNames } from '@ember-decorators/component';

@classNames('app-options')
export default class AppOptions extends Component {
  // Services
  @service
  features;

  @service
  options;

  // Params
  // model expects:
  // {
  //   group: The school app options group.
  //   headings: The option headings for this option group.
  //   options: The options for this option group.
  // }
  model = null;

  // school contains the school to display app options for.
  @tracked school = null;

  // The form to register the rendered fields with, so they count towards the
  // form's validity.
  parentComponent = null;

  @alias('features.heroPremierEnabled')
  premierEnabled;

  @optionAlias(Options.NOTIFICATIONS_APP_ENABLED)
  pushNotificationsEnabled;

  @optionAlias(Options.CONTENT_IS_VIEWABLE)
  learningContentEnabled;

  @optionAlias('core:studentGoalSetting:enabled')
  studentGoalSettingEnabled;

  @optionAlias(Options.APP_LINKS_GOOGLE_CALENDAR)
  schoolCalendarEnabled;

  @optionAlias(Options.APP_LINKS_SCHOOL_WEBSITE)
  schoolWebsite;

  @optionAlias(Options.APP_LINKS_HAIL)
  hail;

  @optionAlias(Options.APP_LINKS_POLICIES)
  policies;

  @optionAlias(Options.APP_LINKS_SHOP)
  shop;

  @optionAlias(Options.APP_LINKS_INSTAGRAM)
  instagram;

  @optionAlias(Options.APP_LINKS_TWITTER)
  twitter;

  @optionAlias(Options.APP_LINKS_FACEBOOK)
  facebook;

  @or(
    'schoolWebsite',
    'hail',
    'policies',
    'shop',
    'instagram',
    'twitter',
    'facebook',
  )
  anyLinkEnabled;

  @optionAlias(Options.APP_FEATURE_ABSENCE_REPORTING)
  absenceReportingEnabled;

  // dummy learners
  get learners() {
    return [
      {
        id: null,
        school_id: this.school.id,
        image: '/assets/images/options/Boy+Hero.png',
        fullName: 'Boy Hero',
        firstName: 'Student A',
      },
      {
        id: null,
        school_id: this.school.id,
        image: '/assets/images/options/Girl+Hero.png',
        fullName: 'Girl Hero',
        firstName: 'Student B',
      },
    ];
  }
}
